var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('h3',[_vm._v("Update Product")]),_c('product-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-product":_vm.updateProduct}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }